import React, { useState, useEffect } from 'react';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { Link, Route, useHistory } from 'react-router-dom';
import { FaChartBar, FaPlusSquare, FaSchool } from 'react-icons/fa';

import ChoixEcole from './souscomposants/ChoixEcole';

import Bunexe_service from '../../Bunexe_service';
import Nouveaueni from './souscomposants/Nouveauenic';
import Statenic from './souscomposants/Statenic';
import Stats_par_siege from './souscomposants/Stats_par_siege';
import Nouveauenic from './souscomposants/Nouveauenic';

const Enic = ({ match, code_dept, info }) => {
  // const l = useLocation();
  // const n = l.pathname;
  const [ecole_selection, setEcole_selection] = useState(null);
  const [titre_, setTitre_] = useState('');
  const histo = useHistory();
  const cheminpush = '/enic/capiste';

  const getTitre = () => {
    let T = Bunexe_service.depts.filter((d) => d.code == code_dept)[0].titre;
    setTitre_(T);
  };

  useEffect(() => {
    getTitre();
  }, []);
  useEffect(() => {
    histo.push('/enic/stat');
  }, [histo]);

  return (
    <div>
      {Bunexe_service.depts
        .filter((d) => d.code == code_dept)
        .map((dd) => {
          // setTitre_(dd.titre);
          return (
            <h1 className='text-center' key={dd.code}>
              {dd.titre}
            </h1>
          );
        })}
      <h3 className='text-center'>
        ENI - Ecole Normale des Instituteurs (Capiste)
      </h3>
      {
        <>
          <div className='d-flex justify-content-center'>
            <Button className='bg-info mr-1' as={Link} to='/enic/stat'>
              <FaChartBar size={20} />
            </Button>
            <Button className='bg-info mr-1' as={Link} to='/enic/capiste'>
              <FaPlusSquare size={20} />
            </Button>
            <Button className='bg-info mr-1' as={Link} to='/enic/choix'>
              <FaSchool size={20} />
            </Button>
          </div>
        </>
      }

      {/* <p className='mx-auto justify-content-center'>
        <Link to='/SecI/ns1' style={{ marginRight: '10px' }}>
          Nouveau
        </Link>
        <Link to='/SecI/choix'>Choix Ecole</Link>
      </p> */}
      {/* <h2>{`${match.url}/ns1`}</h2>
      <h4>{n}</h4> */}

      <Route
        exact
        path='/enic/capiste'
        render={(props) =>
          !ecole_selection ? (
            <ChoixEcole
              {...props}
              setEcole_selection={setEcole_selection}
              code_dept={code_dept}
              cheminpush={cheminpush}
              info_={info}
            />
          ) : (
            <Nouveauenic
              {...props}
              ecole_selection={ecole_selection}
              titre_={titre_}
              info_={info}
            />
          )
        }
      />
      <Route
        exact
        path='/enic/choix'
        render={(props) => (
          <ChoixEcole
            setEcole_selection={setEcole_selection}
            code_dept={code_dept}
            cheminpush={cheminpush}
            info_={info}
          />
        )}
      />

      {/* <Route
        exact
        path='/eni/stat'
        render={(props) => <Stateni code_dept={code_dept} />}
      /> */}

      <Route
        exact
        path='/enic/stat'
        render={(props) => (
          <Stats_par_siege code_dept={code_dept} titre_={titre_} />
        )}
      />
      {/* <Route path='/choix' component={ChoixEcole} /> */}
    </div>
  );
};

export default Enic;
